import { render, staticRenderFns } from "./UserPermissionsTagTableRow.vue?vue&type=template&id=8cd4b3fa&scoped=true&"
import script from "./UserPermissionsTagTableRow.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsTagTableRow.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsTagTableRow.vue?vue&type=style&index=0&id=8cd4b3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd4b3fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
